import LogisticsPageHero from '../Logistics/LogisticsPageHero';

const FAQHero = () => (
  <LogisticsPageHero
    ariaLabel="Fulfilment frequently asked questions"
    imageSrc="/Images/FAQ.webp"
    imageAlt="Pick Pack Pro fulfilment and Amazon FBA FAQs"
    titleLight="Fulfilment FAQs UK"
    titleAccent="Expert Answers for E-Commerce Businesses"
    description={
      <>
        <p>
          Whether you’re choosing your first UK fulfilment partner or switching from another 3PL, finding clear answers is essential before you commit. Our fulfilment experts have answered the questions we receive most often about pick-and-pack fulfilment, Amazon FBA prep, Seller Fulfilled Prime (SFP), warehousing, pricing, integrations, shipping, and returns. Browse our FAQs to learn how Pick Pack Pro helps businesses across the UK scale with transparent pricing, real-time inventory visibility and reliable fulfilment services.
        </p>
        {/* <p>
          Can&apos;t find what you need? Contact our UK support team for a straight answer.
        </p> */}
      </>
    }
    features={[
      'Picking Fees from £0.99',
      'Next-Day Shipping from £1.99',
      '99.9% Order Accuracy',
      'Dedicated Account Manager',
      'Price Match Promise',
    ]}
    primaryCta={{ label: 'Contact support', to: '/contact-fulfillment-services' }}
  />
);

export default FAQHero;
